import { authHeader, utils } from "../helpers";

const apiUrl = process.env.REACT_APP_API_URL;

interface Content {
    [key: string]: any;
}

interface getAllArgs {
    level?: any;
    category?: any;
}

export const contentService = {
    getAll,
    getTopics,
    sendAnswer,
    getAnswerResults,
    getAnswerResultsStudent
};


function getAll({level, category}: getAllArgs): Promise<Content[]> {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: authHeader()
    };

    let url = `${apiUrl}/api/contents?per_page=999999`;

    if (level !== undefined && level !== null) {
        url += `&level_id=${level}`;
    }

    if (category !== undefined && category !== null) {
        url += `&category_id=${category}`;
    }

    return fetch(url, requestOptions)
        .then(utils.handleResponse)
        .then((res: { data: Content[] }) => {
            return res.data;
        })
        .catch((error: any) => {
            return Promise.reject(error);
        });
}


function getTopics(level?: number | string): Promise<Content[]> {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: authHeader()
    };

    let url = `${apiUrl}/api/topics?per_page=999999`;

    // Conditionally add level_id if provided
    if (level !== undefined && level !== null) {
        url += `&level_id=${level}`;
    }

    return fetch(url, requestOptions)
        .then(utils.handleResponse)
        .then((res: { data: Content[] }) => {
            return res.data;
        })
        .catch((error: any) => {
            return Promise.reject(error);
        });
}

function sendAnswer(content_id: number, answer: string){
    const requestOptions: RequestInit = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({
            answer
        })
    };
    return fetch(`${apiUrl}/api/contents/${content_id}/answer-text`, requestOptions)
        .then(utils.handleResponse)
        .then((res) => {
            return res.data;
        })
        .catch((error: any) => {
            return Promise.reject(error);
        });
}

function getAnswerResults(content_id: number) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: authHeader()
    };
    return fetch(`${apiUrl}/api/contents/${content_id}/answer-texts`, requestOptions)
        .then(utils.handleResponse)
        .then((res) => {
            return res.data;
        })
        .catch((error: any) => {
            return Promise.reject(error);
        });
}

function getAnswerResultsStudent(content_id: number, student_id: string) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: authHeader()
    };
    return fetch(`${apiUrl}/api/students/${student_id}/answer-texts/${content_id}`, requestOptions)
        .then(utils.handleResponse)
        .then((res) => {
            return res.data;
        })
        .catch((error: any) => {
            return Promise.reject(error);
        });
}